import { setUpOnboardingConfig } from 'growth-onboarding-signup-redirect/redirect';
import { Data } from '../signup-data/DATA';
import { getIntentLink } from '../intents/intentSelectors';
import { getHublet, getIsNewUser } from '../store/app/selectors';
import { getAuth, getPortalId } from '../store/auth/selectors';
import { getSignupDataValue, isSignupDataCompleted } from '../store/signup-data/selectors';
import { getSurveyDataForRedirect } from '../store/signup-data/selectors';
import { getOnboardingUrl } from './getOnboardingUrl';
import { getRedirectSignupType } from './getRedirectSignupType';
import { getSpecificEnrollment, getSpecificRedirect } from './getFlowSpecificRedirect';
import { getSentryExtra } from '../error/getSentryExtra';
import Logger from '../lib/Logger';
import { getFlowKey } from '../routing/getFlowKey';
import { getIntegrationKey } from '../routing/getIntegrationKey';
import getOnboardingRedirectOptions from './getOnboardRedirectOptions';
const LOG = Logger.getLogger('getRedirectMethod');
export const getRedirectMethod = state => {
  const portalId = getPortalId(state);
  const auth = getAuth(state);
  const hublet = getHublet(state);
  const survey = getSurveyDataForRedirect(state);
  const intentLink = getIntentLink(state);
  const signupType = getRedirectSignupType();
  const specificRedirect = getSpecificRedirect();
  const specificEnrollment = getSpecificEnrollment();
  const flowKey = getFlowKey();
  const integrationKey = getIntegrationKey();
  const isNewUser = getIsNewUser(state);
  return specificRedirect ? () => {
    let promise = Promise.resolve();

    if (specificEnrollment) {
      const options = getOnboardingRedirectOptions(portalId, specificEnrollment, hublet, auth, survey);
      promise = setUpOnboardingConfig(options);
    }

    return promise.then(() => specificRedirect(state)).catch(error => {
      LOG.error(`Failed to build specific redirect for flow: ${flowKey} ${integrationKey}`, {
        extra: getSentryExtra(error)
      });
      return Promise.reject(error);
    });
  } : () => {
    return getOnboardingUrl({
      portalId,
      auth,
      survey,
      intentLink,
      hublet,
      businessBoxId: isSignupDataCompleted(state, Data.BusinessBox) && getSignupDataValue(state, Data.BusinessBox)
    }, signupType, isNewUser);
  };
};